export enum LayoutPanel {
  LEFT_PANEL = 'LEFT_PANEL',
  INNER_LEFT_PANEL = 'INNER_LEFT_PANEL',
  RIGHT_PANEL = 'RIGHT_PANEL',
  INNER_RIGHT_PANEL = 'INNER_RIGHT_PANEL',
}

export interface LayoutPanelConfig {
  [LayoutPanel.LEFT_PANEL]: {
    open: boolean
    content: LEFT_PANEL_CONTENT
    ignoreMaxConstraints: boolean
  }
  [LayoutPanel.INNER_LEFT_PANEL]: {
    open: boolean
    content: LEFT_PANEL_CONTENT
    ignoreMaxConstraints: boolean
  }
  [LayoutPanel.RIGHT_PANEL]: {
    open: boolean
    content: RIGHT_PANEL_CONTENT
    ignoreMaxConstraints: boolean
  }
  [LayoutPanel.INNER_RIGHT_PANEL]: {
    open: boolean
    content: RIGHT_PANEL_CONTENT
    ignoreMaxConstraints: boolean
  }
}

export enum LEFT_PANEL_CONTENT {
  INSIGHTS = 'INSIGHTS',
  LIVE_SAMPLE = 'LIVE_SAMPLE',
}

export enum RIGHT_PANEL_CONTENT {
  ADD_NODE = 'ADD_NODE',
  TRANSFORMATION_STEPS = 'TRANSFORMATION_STEPS',
  TRANSFORMATION_CODE = 'TRANSFORMATION_CODE',
  CODE_EDITOR = 'CODE_EDITOR',
  SOURCES = 'SOURCES',
  DESTINATIONS = 'DESTINATIONS',
  QUERY_BUILDER = 'QUERY_BUILDER',
}
